import { render } from "./reportPage.vue?vue&type=template&id=780b1e52"
import script from "./reportPage.vue?vue&type=script&lang=js"
export * from "./reportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__